import { hasCodeInUrl, initUserManager } from 'oidc-react';
import { buildOidcConfig } from './auth-provider-config';

const hasAuthorizationError = ({ search, hash }: Location): boolean =>
  new URLSearchParams(search).has('error') ||
  new URLSearchParams(hash.replace('#', '?')).has('error');

export const isSilentRenewResponseInFrame = (): boolean =>
  globalThis.self !== globalThis.top &&
  (hasCodeInUrl(globalThis.location) || hasAuthorizationError(globalThis.location));

export const completeSilentRenew = (): Promise<void> =>
  initUserManager(buildOidcConfig()).signinSilentCallback();
